<template>
  <div>
    <vue-headful
      title="404"
      description="Mathew Moose - Software Engineer. This is a portfolio site used to showcase some of my work."
    />
    <div class="container">
      <p class="title is-1 has-text-centered">{{title}}</p>
      <p class="subtitle is-3 has-text-centered">{{msg}}</p>
      <router-link to="/">Back to Home Page</router-link>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      msg: 'Page not found.',
      title: 'Error 404'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/404NotFound.vue